import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=433278a8&scoped=true&"
import script from "./MenuList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=433278a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433278a8",
  null
  
)

export default component.exports